import React from "react";
import { Button, Grid, Typography, Box, CardMedia } from "@mui/material";
import drop from "../../assets/images/drop.jpeg";

const ClaimsCard = ({
  mintData,
  setPrintTeeModal,
  supply,
  token,
  setMintClaim,
  claimedtoken,
}) => {
  return (
    <Grid item xs={12} md={6} align="center" mt="10px">
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        boxShadow="2"
        marginTop="10px"
      >
        <Box
          sx={{
            height: "250px",
            border: "2px solid black",
            backgroundColor: "black",
          }}
        >
          <CardMedia
            component="img"
            image={drop}
            alt="image"
            sx={{ height: "250px", width: "250px" }}
          />
        </Box>

        <Typography mt="5px" fontWeight="bold">
          DOTR #{token}/{supply}
        </Typography>

        <Typography fontWeight="bold" fontSize="30px">
          paint | NFT
        </Typography>
        <Typography fontSize="12px" marginBottom="10px">
          A young Ukrainian girl defiantly painting a new future because
          self-belief is the best middle finger to oppression.
        </Typography>
        <Box sx={{ pt: "40px", pb: "30px" }}>
          {claimedtoken ? (
            claimedtoken.includes(token) ? (
              <Button
                variant="contained"
                sx={{ fontWeight: "bold" }}
                disabled
                onClick={() => {
                  setMintClaim({ token: token, hashcode: mintData.hashCode });
                  setPrintTeeModal(true);
                }}
              >
                Claimed
              </Button>
            ) : (
              <Button
                variant="contained"
                sx={{ fontWeight: "bold" }}
                onClick={() => {
                  setMintClaim({ token: token, hashcode: mintData.hashCode });
                  setPrintTeeModal(true);
                }}
              >
                Print Tee
              </Button>
            )
          ) : (
            <Button
              variant="contained"
              sx={{ fontWeight: "bold" }}
              onClick={() => {
                setMintClaim({ token: token, hashcode: mintData.hashCode });
                setPrintTeeModal(true);
              }}
            >
              Print Tee
            </Button>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

export default ClaimsCard;
